/* eslint-disable camelcase, no-invalid-this */
import { html } from 'lit-element';
import { ifDefined } from 'lit-html/directives/if-defined';
import { FIELD_TYPES } from '../../fc-form-field-helper';

const DEFAULT_CURRENCY_SYMBOL = '$';
const TYPES_WITH_NO_VALIDATION = ['text'];

export const render_input = function() {
  const {
    value,
    disabled,
    readonly,
    placeholder,
    maxlength,
    minlength,
    type,
    min,
    max,
    currencysymbol,
    required,
    label,
    extended,
    warning,
    valid,
    validations,
    pattern
  } = this;
  // Lets the fc-form-field manage the invalid state of the fc-input
  const noValidation = TYPES_WITH_NO_VALIDATION.includes(type) && validations?.length;
  const isCurrencyType = type === FIELD_TYPES.CURRENCY;
  const inputType = isCurrencyType ? FIELD_TYPES.NUMBER : type;
  return html`
      <fc-input
            style="${extended ? `width: auto` : ''}"
            maxlength="${ifDefined(maxlength)}"
            minlength="${ifDefined(minlength)}"
            min="${ifDefined(min)}"
            max="${ifDefined(max)}"
            pattern="${ifDefined(pattern)}"
            value="${ifDefined(value)}"
            label="${ifDefined(placeholder)}"
            warning="${ifDefined(warning)}"
            name="${ifDefined(label)}"
            ?readOnly="${readonly}"
            ?disabled="${disabled}" 
            ?required="${required}" 
            ?invalid="${!valid}"
            ?novalidation="${noValidation}"
            type="${inputType}"
            @keyup="${this.setValue}"
            @change="${this.setValue}">
            ${isCurrencyType && html`<div slot="prefix">${currencysymbol || DEFAULT_CURRENCY_SYMBOL}</div>`}
      </fc-input>
    `;
};
